<div class="flex flex-col gap-8 p-5">
    <p class="font-medium text-4xl">{{ title }}</p>
    <form class="flex flex-col gap-3" [formGroup]="paymentInformationForm" (ngSubmit)="onSubmit()">
        <div class="flex gap-3 w-full [&>*]:flex-grow">
            <mat-form-field>
                <mat-label>First Name on Account</mat-label>
                <input
                        matInput
                        type="text"
                        [formControl]="paymentInformationForm.controls.firstName"
                        placeholder="First name"
                        (focus)="
              paymentInformationForm.controls.firstName.markAsUntouched()
            "
                />
                <mat-error
                        *ngIf="ValidationHelperService.isInvalid(paymentInformationForm.controls.firstName)"
                >
                    {{ValidationHelperService.getErrorMessage(paymentInformationForm.controls.firstName)}}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Last Name on Account</mat-label>
                <input
                        matInput
                        type="text"
                        [formControl]="paymentInformationForm.controls.lastName"
                        placeholder="Last name"
                        (focus)="
              paymentInformationForm.controls.lastName.markAsUntouched()
            "
                />
                <mat-error
                        *ngIf="ValidationHelperService.isInvalid(paymentInformationForm.controls.lastName)"
                >
                    {{ValidationHelperService.getErrorMessage(paymentInformationForm.controls.lastName)}}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="flex gap-3 [&>*]:flex-grow">
            <mat-form-field>
                <mat-label>Card Number</mat-label>
                <input
                        matInput
                        type="text"
                        [formControl]="paymentInformationForm.controls.cardNumber"
                        placeholder="Card number"
                        (focus)="
              paymentInformationForm.controls.cardNumber.markAsUntouched()
            "
                />
                <mat-error
                        *ngIf="
              !paymentInformationForm.controls.cardNumber.valid &&
              paymentInformationForm.controls.cardNumber.touched
            "
                >
                    This is not a valid or supported card number format.
                </mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="useMonthVector">
                <mat-label>Expiration Month</mat-label>
                <mat-select
                        [formControl]="paymentInformationForm.controls.selectedMonth"
                >
                    <mat-option *ngFor="let month of monthVector" [value]="month">
                        {{ month }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="!useMonthVector">
                <mat-label>Expiration Month</mat-label>
                <mat-select
                        [formControl]="paymentInformationForm.controls.selectedMonth"
                >
                    <mat-option *ngFor="let month of currentMonthVector" [value]="month">
                        {{ month }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="flex gap-3 [&>*]:flex-grow">
            <mat-form-field>
                <mat-label>CVV</mat-label>
                <input
                        matInput
                        type="text"
                        [formControl]="paymentInformationForm.controls.CVV"
                        placeholder="CVV"
                        (focus)="paymentInformationForm.controls.CVV.markAsUntouched()"
                />
                <mat-error
                        *ngIf="ValidationHelperService.isInvalid(paymentInformationForm.controls.CVV)"
                >
                    {{
                        ValidationHelperService.getErrorMessage(paymentInformationForm.controls.CVV)
                    }}
                </mat-error>
                <mat-error
                        *ngIf="
              paymentInformationForm.controls.CVV.hasError('invalidCVV') &&
              paymentInformationForm.controls.CVV.touched
            "
                >
                    The CVV must be 3 digits.
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Expiration Year</mat-label>
                <mat-select
                        [formControl]="paymentInformationForm.controls.selectedYear"
                        (selectionChange)="validateDate()"
                >
                    <mat-option *ngFor="let year of yearVector" [value]="year">
                        {{ year }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="flex justify-end gap-3 flex-wrap">
            <button *ngIf="mode === 'default'" mat-flat-button color="warn" type="button" (click)="cancel()">Cancel</button>
            <button
                *ngIf="mode === 'default'"
                    mat-flat-button
                    color="primary"
                    [disabled]="!paymentInformationForm.valid || isLoading || disabled"
            >
                <ng-container *ngIf="!isLoading">Save</ng-container>
                <ng-container *ngIf="isLoading">Loading...</ng-container>
            </button>
            <button
                    *ngIf="mode === 'subscriptionUpgrade' && hasPaymentMethod"
                    mat-flat-button
                    type="button"
                    color="primary"
                    (click)="retryPayment()"
                    [disabled]="isLoading || disabled"
            >
                <ng-container *ngIf="!isLoading">Retry</ng-container>
                <ng-container *ngIf="isLoading">Loading...</ng-container>
            </button>
            <button
                    mat-flat-button
                    type="button"
                    (click)="saveAndRetryClick()"
                    color="primary"
                    [disabled]="!paymentInformationForm.valid || isLoading || disabled"
            >
                {{ hasPaymentMethod ? "Save and retry payment" : "Save and pay" }}
            </button>
        </div>
    </form>
</div>

